import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../config/fbConfig";

// Importing CSS for styling
import "./header.css";

// Define the Header component
const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Function to get the current user
  useEffect(() => {
    // Listen for auth changes
    const unsubscribe = onAuthStateChanged(auth, (user) => { setCurrentUser(user); });
    return () => unsubscribe();
  }, []);

  // Update isMobile state on window resize
  useEffect(() => {
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  // Check if the screen size is mobile
  const checkIfMobile = () => { setIsMobile(window.innerWidth <= 768); };

  // function to toggle menu
  const toggleMenu = () => { setIsMenuOpen(!isMenuOpen); };

  // Function to handle logout
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <header>
      {/* Top bar section with contact info */}
      <div className="header-top-bar">
        <div className="container">
          <div className="row align-items-center">
            {/* Left section of top bar - contact info */}
            <div className="col-lg-6 d-none d-lg-block">
              <ul className="top-bar-info list-inline-item pl-0 mb-0">
                {/* Email */}
                <li className="list-inline-item">
                  <a href="mailto:support@gmail.com">
                    <i className="icofont-support-faq mr-2"></i>varenyamatrimonial@gmail.com
                  </a>
                </li>
                {/* Address */}
                <li className="list-inline-item">
                  <i className="icofont-location-pin mr-2"></i># 755, I Block, Ramakrishna Nagar, Mysuru
                </li>
              </ul>
            </div>

            {/* Right section of top bar - phone number */}
            <div className="col-lg-6 text-center">
              <div className="text-lg-right top-right-bar mt-2 mt-lg-0">
                <a href="tel:+23-345-67890">
                  <span>Call Now : </span>
                  <span className="h4">+91 63603 34247</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation bar */}
      <nav className="navbar navbar-expand-lg navigation" id="navbar">
        <div className="container">
          {/* Logo section */}
          <Link className="navbar-brand" to="/">
            <img src="images/logo.png" alt="" className="img-fluid" />
          </Link>

          {/* Hamburger menu toggle for mobile devices */}
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarmain"
            aria-controls="navbarmain"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ color: 'maroon' }}
            onClick={toggleMenu}
          >
            <span className="icofont-navigation-menu"></span>
          </button>

          {/* Collapsible navigation links */}
          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
            id="navbarmain"
          >
            <ul className="navbar-nav ml-auto">
              {/* Home link */}
              <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                <Link className="nav-link" to="/" onClick={toggleMenu}>Home</Link>
              </li>

              {/* About link */}
              <li className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}>
                <Link className="nav-link" to="/about" onClick={toggleMenu}>About</Link>
              </li>

              {/* Pricing link */}
              <li className={`nav-item ${location.pathname === '/pricing' ? 'active' : ''}`}>
                <Link className="nav-link" to="/pricing" onClick={toggleMenu}>Pricing</Link>
              </li>

              {/* Register link */}
              <li className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}>
                <Link className="nav-link" to="/contact" onClick={toggleMenu}>Register</Link>
              </li>

              {/* Pipe separator for large screens */}
              <li className="nav-item separator pipe-separator">
                <span className="nav-link">|</span>
              </li>

              {/* Horizontal line for small screens */}
              <li className="nav-item separator hr-separator">
                <hr style={{ margin: '10px 0', borderColor: '#ccc' }} />
              </li>

              {/* Conditionally Render Login or Dashboard + Logout */}
              {currentUser ? (
                <>
                  {/* Dashboard link */}
                  <li className={`nav-item ${location.pathname === "/dashboard" ? "active" : ""}`}>
                    <Link className="nav-link" to="/login" onClick={toggleMenu}>
                      <span className="icon-hide-mobile">
                        <i className="icofont-home" style={{ marginRight: "5px" }}></i>
                      </span>
                      Dashboard
                    </Link>
                  </li>

                  {/* Logout link */}
                  <li className="nav-item">
                    <Link className="nav-link" onClick={(e) => { e.preventDefault(); handleLogout(); toggleMenu(); }}>
                      <span className="icon-hide-mobile">
                        <i className="icofont-logout" style={{ marginRight: "5px" }}></i>
                      </span>
                      Logout
                    </Link>
                  </li>
                </>
              ) : (
                <li className={`nav-item ${location.pathname === "/login" ? "active" : ""}`}>
                  <Link className="nav-link" to="/login" onClick={toggleMenu}>
                    <span className="icon-hide-mobile">
                      <i className="icofont-user" style={{ marginRight: "5px" }}></i>
                    </span>
                    Login
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};


export default Header;
